import NumberFlow, { NumberFlowGroup } from '@number-flow/react'
import { cx } from 'src/utils/cx'
import dayjs from 'src/utils/dayjs'
import Countdown from '../../../components/Countdown'

export type MembershipCountdownProps = {
  expireAt: dayjs.Dayjs
  maximumLeftDays?: number
} & StyleProps

export const MembershipCountdown = ({
  className,
  style,
  expireAt,
}: MembershipCountdownProps) => {
  return (
    <Countdown targetDate={expireAt}>
      {({ timeLeft }) => (
        <CountdownNumberFlow
          timeLeft={timeLeft}
          className={className}
          style={style}
        />
      )}
    </Countdown>
  )
}

type CountdownNumberFlowProps = {
  timeLeft: number
} & StyleProps

const CountdownNumberFlow = ({
  timeLeft,
  className,
  style,
}: CountdownNumberFlowProps) => {
  const duration = dayjs.duration(timeLeft)
  const days = Math.floor(duration.asDays())
  const [hours, minutes, seconds] = duration
    .format('H:m:s')
    .split(':')
    .map(Number)

  const arr = [days, hours, minutes, seconds]

  return (
    <span
      className={cx(
        'inline-grid grid-flow-col items-center tabular-nums',
        className,
      )}
      style={style}
    >
      <NumberFlowGroup>
        {arr.map((num, idx) => (
          <>
            {idx > 0 && ':'}
            <NumberFlow
              key={idx}
              value={num}
              trend={-1}
              suffix={idx === 0 ? 'D' : undefined}
              digits={idx === 0 ? undefined : { 1: { max: 5 } }}
              format={idx === 0 ? undefined : { minimumIntegerDigits: 2 }}
            />
          </>
        ))}
      </NumberFlowGroup>
    </span>
  )
}
